
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <div className="flex items-center">
            <img
              src="https://public.readdy.ai/ai/img_res/55f58ff0-c5af-4885-85a2-2e0c07bea16a.png"
              alt="Fireline Email Co."
              className="h-12 w-auto"
            />
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('how-it-works')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-red-600' : 'text-white hover:text-red-400'
              }`}
            >
              How It Works
            </button>
            <button
              onClick={() => scrollToSection('samples')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-red-600' : 'text-white hover:text-red-400'
              }`}
            >
              Samples
            </button>
            <button
              onClick={() => scrollToSection('pricing')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-red-600' : 'text-white hover:text-red-400'
              }`}
            >
              Pricing
            </button>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-red-600' : 'text-white hover:text-red-400'
              }`}
            >
              About
            </Link>
            <button
              onClick={() => scrollToSection('final-cta')}
              className="bg-red-600 text-white px-6 py-2.5 rounded-md text-sm font-semibold hover:bg-red-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Book a Call
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
